import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import GlobalInvoicesView from './GlobalInvoices';
import GlobalPaymentsView from './GlobalPayments';

const TransactionView = () => {
  return (
    <Routes>
      <Route index element={<RolePrivateRoute component={GlobalInvoicesView} />} />
      <Route
        path="payments"
        element={<RolePrivateRoute component={GlobalPaymentsView} />}
      />
    </Routes>
  );
};

export default TransactionView;
